import * as React from 'react';
import FelaComponent from './fela-component';
var rule = function (_a) {
    var theme = _a.theme, height = _a.height, size = _a.size, marginTop = _a.marginTop;
    return ({
        minHeight: 30,
        height: height,
        marginTop: marginTop,
        position: 'relative',
        marginX: 'auto',
        '> div': {
            paddingX: theme.space2
        },
        onAfter: {
            content: '""',
            clear: 'both',
            display: 'block',
            visibility: 'hidden',
            height: 0
        },
        ifMini: {
            width: '100%'
        },
        ifSmallUp: {
            width: 540,
            maxWidth: '100%'
        },
        ifMediumUp: {
            width: 720,
            maxWidth: '100%'
        },
        ifLargeUp: {
            width: 960,
            maxWidth: '100%'
        },
        ifHugeUp: {
            width: 1140,
            maxWidth: '100%'
        },
        extend: [
            {
                condition: size === 'small',
                style: {
                    onAfter: {
                        content: '""',
                        clear: 'both',
                        display: 'block',
                        visibility: 'hidden',
                        height: 0
                    },
                    ifMediumUp: {
                        width: 400,
                        maxWidth: '100%'
                    },
                    ifLargeUp: {
                        width: 520,
                        maxWidth: '100%'
                    },
                    ifHugeUp: {
                        width: 640,
                        maxWidth: '100%'
                    }
                }
            }
        ]
    });
};
export var Container = function (_a) {
    var render = _a.render, marginTop = _a.marginTop, height = _a.height, children = _a.children, size = _a.size, className = _a.className;
    return (React.createElement(FelaComponent, { rule: rule, height: height, marginTop: marginTop, size: size, render: render },
        React.createElement("div", { className: className }, children)));
};
Container.displayName = 'Container';
export default Container;
//# sourceMappingURL=container.js.map